/**
 * Environment Configuration
 * 
 * This module centralizes all environment variable access and provides
 * type-safe defaults for all configuration values.
 */

// Environment detection
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
export const isTest = process.env.NODE_ENV === 'test';

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://api.blinklink.com',
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  VERSION: process.env.REACT_APP_API_VERSION || 'v1',
};

// Feature Flags
export const FEATURES = {
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_NOTIFICATIONS: process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true',
  ENABLE_DARK_MODE: process.env.REACT_APP_ENABLE_DARK_MODE !== 'false', // Default to true
};

// Authentication Configuration
export const AUTH_CONFIG = {
  TOKEN_KEY: process.env.REACT_APP_TOKEN_KEY || 'blinklink_token',
  TOKEN_EXPIRY_KEY: process.env.REACT_APP_TOKEN_EXPIRY_KEY || 'blinklink_token_expiry',
  REFRESH_TOKEN_KEY: process.env.REACT_APP_REFRESH_TOKEN_KEY || 'blinklink_refresh_token',
};

// App Configuration
export const APP_CONFIG = {
  APP_NAME: process.env.REACT_APP_NAME || 'BlinkLink Creator',
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'support@blinklink.com',
  MAX_UPLOAD_SIZE: parseInt(process.env.REACT_APP_MAX_UPLOAD_SIZE || '100', 10) * 1024 * 1024, // Default 100MB
};

// Export all environment variables as a single object for convenience
export default {
  isDevelopment,
  isProduction,
  isTest,
  API: API_CONFIG,
  FEATURES,
  AUTH: AUTH_CONFIG,
  APP: APP_CONFIG,
};
